var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-object-card__macro-cam"},[_c('img',{staticClass:"sc-object-card__macro-cam__image",attrs:{"src":_vm.src,"alt":"no-data"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }